export const subCategoryItemTemplate = (itemClass, itemImg, itemName, itemHref, dataId) =>`
<a href="${itemHref}" class="nav-item ${itemClass}" data-id="${dataId}">
    <span class="item-image">
        <img src="${itemImg}" width="32" height="32" />
        <svg class="icon arrow"><use xlink:href="#icon-arrow_right"></use></svg>
    </span>
    <span class="item-name">
        ${itemName}
    </span>
</a>
`